import React, { Component } from "react";
import Icon from "./Icons";
import { l } from "../functions";
import PayloadsList from "./PayloadsList";
import MenuItems from "./MenuItems";
import PagesList from "./PagesList";
import ThemesPalette from "./ThemesPalette";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    toCopy: state.rootReducer.toCopy || null,
  };
};

const ucFirst = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
export class SidePalette extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log(this.props);
  }
  render() {
    const { palette, currentPalette } = this.props;
    const { tabs, sideTitle, title } = palette;
    return (
      <>
        {currentPalette === palette.id && (
          <div className="side-palette">
            {palette.id === "pages" && (
              <PagesPalette
                currentPage={this.props.currentPage}
                title={sideTitle}
                closeEvent={this.props.closeEvent}
                copyIt={this.props.copyIt}
              />
            )}
            {palette.id === "themes" && (
              <ThemesPalette
                closeEvent={this.props.closeEvent}
                showCustomize={this.props.showCustomize}
              />
            )}
          </div>
        )}
      </>
    );
  }
}

export default SidePalette;

class PagesPalette_c extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 1,
      currentPayload: "pages",
    };

    this.showPayloadList = this.showPayloadList.bind(this);
  }
  showPayloadList = (target) => {
    this.setState({
      currentPayload: target,
    });
  };

  componentDidMount() {
    if (this.props.toCopy) {
      //Perform some operation here
      this.setState({ currentTab: this.props.toCopy !== null ? 1 : 2 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.toCopy !== this.props.toCopy) {
      //Perform some operation here
      this.setState({ currentTab: this.props.toCopy !== null ? 1 : 2 });
    }
  }
  render() {
    return (
      <>
        <div className="tabs-side">
          <h1>{this.props.title}</h1>
          <ul>
            <li
              className={`${this.state.currentTab === 1 ? "active" : ""}`}
              onClick={() => this.setState({ currentTab: 1 })}
            >
              {l("Pages")}
            </li>
            {this.props.toCopy === null && (
              <li
                className={this.state.currentTab === 2 ? "active" : ""}
                onClick={() => {
                  this.setState({ currentTab: 2 });
                }}
              >
                {l("Navigation")}
              </li>
            )}
          </ul>
        </div>
        <div className="content-side">
          {this.props.toCopy !== null && (
            <div className="cancel-btn" onClick={() => this.props.copyIt(null)}>
              {" "}
              Cancel
            </div>
          )}
          <div className="head">
            <h1>{this.state.currentTab === 1 ? "Pages" : "Site Navigation"}</h1>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                onClick={() => this.props.closeEvent()}
              >
                <path
                  stroke="#A4A8C0"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="1.5"
                  d="M18.118 17h-7.53M20 12.168H4.941M18.118 7h-7.53M6.51 14.823L4 11.913l2.51-2.894"
                ></path>
              </svg>
            </div>
          </div>
          <div className="side-container">
            {this.state.currentTab === 1 && (
              <div className="pages">
                {(this.state.currentPayload === "pages" && (
                  <PagesList
                    currentPage={this.props.currentPage}
                    goToLayout={this.showPayloadList}
                  />
                )) || (
                  <div
                    className={`payloads-list ${
                      this.props.toCopy ? "copy-list" : ""
                    }`}
                  >
                    <div className="head">
                      <h3>
                        {ucFirst(this.state.currentPayload)} {l("Page Layouts")}
                      </h3>
                      <Icon
                        icon="angle-left"
                        onClick={() => {
                          this.showPayloadList("pages");
                        }}
                      />
                    </div>
                    <div className="form">
                      <PayloadsList
                        currentPage={this.props.currentPage}
                        target={this.state.currentPayload}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {this.state.currentTab === 2 && (
              <>
                <MenuItems />
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

const PagesPalette = connect(mapStateToProps)(PagesPalette_c);
